import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, requiredRoles }) => {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRoles && requiredRoles.length > 0) {
    const role = (user?.role || '').toLowerCase();
    const allowed = requiredRoles.map((r) => r.toLowerCase());
    if (!allowed.includes(role)) {
      if (role === 'admin') return <Navigate to="/admin/dashboard" replace />;
      if (role === 'engineer') return <Navigate to="/engineer/dashboard" replace />;
      return <Navigate to="/user/dashboard" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
